export default __webpack_public_path__ + "static/media/weather.529f7b65.svg";